import { graphql } from 'GQL/gql';

export const GET_MARKET_OPPORTUNITIES = graphql(`
  query GET_MARKET_OPPORTUNITIES(
    $perPage: Int
    $page: Int
    $filter: MarketOpportunityFilterInputType
    $sortBy: String
    $sortDirection: String
  ) {
    marketOpportunities(
      perPage: $perPage
      page: $page
      filter: $filter
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      __typename
      count
      items {
        ...MarketOpportunityFields
      }
      pageInfo {
        pageCount
        itemCount
        hasNextPage
        hasPreviousPage
        currentPage
        perPage
      }
    }
  }
`);
